module.exports = __webpack_public_path__ + "img/shadow-btn2@2x.d47230c8.png";